import React, { ReactElement, useEffect, useState } from 'react';
import { isNilOrEmpty } from '~common/helper/global';
import { ResultAwareTask } from '~common/helper/mobx-tasks';
import { useSuccessReaction } from '~common/hook/use-reaction';
import { SelectFieldOption, SelectFieldProps } from '~common/components/select.component';
import { ThemedSelect } from '~common/components/themed-select.component';

interface Props<T> extends Omit<SelectFieldProps, 'options'> {
  task: ResultAwareTask<any>;
  mapper: (result: T) => SelectFieldOption[];
  taskArgs?: any[];
  disabled?: boolean;
}

export const SelectTask = <T extends object>(props: Props<T>): ReactElement => {
  const { task, mapper, taskArgs, input, meta, disabled, ...rest } = props;
  const [options, setOptions] = useState<SelectFieldOption[]>(undefined);

  useEffect((): void => {
    task?.(taskArgs);
  }, [taskArgs?.toString()]);

  useSuccessReaction(task, (result: T) => {
    setOptions(mapper(result));
  });

  return (
    <ThemedSelect
      options={options}
      input={input}
      meta={meta}
      disabled={disabled || isNilOrEmpty(options)}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/ui/form/select-task.component.tsx